import React, { useState, useEffect } from "react"
import { Row, Col, Container, Button } from "reactstrap"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Modal from "../../components/RopikCustom/Modal";

import moment from "moment";
import { getCmsData, getCompanyOrder, getPaymentList, getTotalCompanyPayment, postCompanyFromId, postPaymentLog, postPaymentReport, postTax, saveCmsData } from "crud/auth.crud";

import Util from "pages/Dashboard/Common/Util";
import { useHistory } from "react-router-dom";
import { ReactComponent as Delete } from 'assets/images/svg/delete.svg';

import loading from "../../assets/images/loading.gif";

const style = { backgroundColor: "#ffffff", padding: "0.5rem", cursor: "pointer", width: '100%', border: '1px solid #bdbdbd', marginTop: '0.5rem', borderRadius: '4px', color: '#333', textAlign: 'center' };

const hoverStyle = { backgroundColor: "#4DBBAA", color: "#ffffff", width: '100%', border: '1px solid #4DBBAA', textAlign: 'center' };

const EmitterBill = props => {
  const selector = useSelector(state => state)
  const newDate = new Date()
  const nextDate = new Date()
  const preDate = new Date()
  const preMonth = new Date()
  const history = useHistory()
  const { IMP } = window

  const [isLoading, setIsLoading] = useState(true);
  const [prevSumData, setPrevSumData] = useState(0);
  const [sumData, setSumData] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [modalShow3, setModalShow3] = useState(false);
  const [payMethod, setPayMethod] = useState();
  const [data, setData] = useState({});
  const [priceObj, setPriceObj] = useState({});
  const [price, setPrice] = useState(0);
  const [pricePerL, setPricePerL] = useState(170);
  const [user, setUser] = useState(selector.auth?.user)
  const [company, setCompany] = useState(selector.auth?.user?.member_group?.[0]?.company_group);
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id);
  const [totalElements, setTotalElements] = useState(0);
  const [page, setPage] = useState(1);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isListEnd, setIsListEnd] = useState(false);
  const [checkedDateType, setCheckedDateType] = useState('');
  const [yearModalShow, setYearModalShow] = useState(false);
  const [monthModalShow, setMonthModalShow] = useState(false);
  const [prevMonth, setPrevMonth] = useState(moment(preMonth).format('DD') > 10 ? moment(preMonth).format('MM') : moment(preMonth.setMonth(preMonth.getMonth() - 1)).format('MM'));
  const [prevDate, setPrevDate] = useState(moment(preDate).format('DD') > 10 ? moment(preDate.setMonth(preDate.getMonth() + 1)).format('MM') + '/10' : moment(preDate).format('MM') + '/10');
  const [startDate, setStartDate] = useState(moment(preMonth.setMonth(preMonth.getMonth()-1)).format('YYYY-MM') + '-01 00:00:00');
  const [endDate, setEndDate] = useState(moment(nextDate).format('YYYY-MM') + '-01 00:00:00');
  const [companyTo, setCompanyTo] = useState('');
  const [modalSuccess, setModalSuccess] = useState(false);
  const [order, setOrder] = useState({});
  const [rsp, setRsp] = useState();
  const [isHover, setIsHover] = useState()
  const [isCms, setIsCms] = useState('')
  const [contractData, setContractData] = useState({})
  const [companyFromId, setCompanyFromId] = useState('')
  const [isPayment, setIsPayment] = useState(true)
  const [cmsBank, setCmsBank] = useState({})
  const [agreeFile, setAgreeFile] = useState(undefined)
  const [bankAccount, setBankAccount] = useState('')
  const [paymentDate, setPaymentDate] = useState('1')

  const payMethodArr = [
    { 'key': 'card', 'text': '신용카드' },
    { 'key': 'trans', 'text': '계좌이체' },
    { 'key': 'phone', 'text': '휴대폰결제' },
  ]

  const bankList = [
    { 'code': '002', 'text': '산업은행' },
    { 'code': '003', 'text': '기업은행' },
    { 'code': '004', 'text': '국민은행' },
    { 'code': '007', 'text': '수협중앙회' },
    { 'code': '020', 'text': '농협은행' },
    { 'code': '023', 'text': 'SC은행' },
    { 'code': '027', 'text': '한국씨티은행' },
    { 'code': '031', 'text': '대구은행' },
    { 'code': '032', 'text': '부산은행' },
    { 'code': '034', 'text': '광주은행' },
    { 'code': '035', 'text': '제주은행' },
    { 'code': '037', 'text': '전북은행' },
    { 'code': '039', 'text': '경남은행' },
    { 'code': '045', 'text': '새마을금고' },
    { 'code': '048', 'text': '신협중앙회' },
    { 'code': '071', 'text': '우체국' },
    { 'code': '081', 'text': 'KEB하나은행' },
    { 'code': '088', 'text': '신한은행' },
    { 'code': '209', 'text': '유안타증권' },
    { 'code': '240', 'text': '삼성증권' },
    { 'code': '089', 'text': '케이뱅크' },
  ]

  const getMyContractList = async () => {

    let params = {
      state: 'Y',
      company: companyId
    }

    const response = await getCmsData(params);
    const content = response.data?.data || [];
    const cmsData = content?.[0]?.contract_group_data?.cms_contract?.[0]
    if (cmsData?.cms_state === 'Y' && cmsData?.status === 'Y') {
      setIsCms('Y') //CMS 사용중
    } else if (cmsData?.status === 'Y') {
      setIsCms('I') //대기중
    } else {
      setIsCms('N')
    }

    if (content.length > 0) {
      setContractData(content[0])
      const param = {
        contract: content[0]?.contract,
        target: 'collection'
      }
      const rs = await postCompanyFromId(param);
      setCompanyFromId(rs.data?.data?.company || '')
    }
  }

  const getDataList = async () => {
    let url = '/payment_report/get_payment_collect_report/?company='
    if (company?.parents_company) {
      const rs = await getTotalCompanyPayment(company?.parents_company);
      rs.data?.data?.[0]?.is_payment_total === 'Y' && setIsPayment(false)
    }
    try {
      const params = {
        company: companyId,
        date: startDate,
      }

      const response = await getPaymentList(url, params);
      if (response.data?.result === 'success') {
        setData(response?.data?.data || [])
      }
      setIsLoading(false)
    } catch (error) {
      console.error(error);
    }
  }

  const selectBank = (item) => {
    setCmsBank(item)
    setModalShow3(false)
  }

  const openBankModal = () => {
    setModalShow3(true)
  }

  const saveCmsMember = async () => {

    setIsLoading(true)

    if (!agreeFile) {
      return alert('동의서 파일을 등록해주세요.');
    }

    try {
      const joinDate = moment().format('YYYYMMDD')

      const fd = new FormData();
      const newFile = new File([agreeFile], `${encodeURI(agreeFile.name)}`, { type: agreeFile.type })
      fd.append('file_0', newFile);

      const cmsData = {
        "memberId": user?.user_id + '_' + contractData?.contract,
        "memberName": user?.username,
        "smsFlag": "N",
        "phone": user?.mobile_phone,
        "email": user?.email,
        "zipcode": company?.zipcode,
        "address1": company?.address1,
        "address2": company?.address2,
        "joinDate": joinDate,
        "receiptFlag": "Y",
        "receiptNumber": user?.mobile_phone,
        "memberKind": "",
        "managerId": "",
        "memo": "",
        "paymentStartDate": "",
        "paymentEndDate": "",
        "paymentDay": parseInt(paymentDate) < 10 ? "0" + paymentDate : paymentDate,
        "defaultAmount": contractData?.contract_group_data?.min_price || 0,
        "paymentKind": "CMS",
        "paymentCompany": cmsBank?.code || '', //셀렉트박스
        "paymentNumber": bankAccount, //계좌번호
        "payerName": user?.username,
        "payerNumber": company?.company_number,
      }
      fd.append('cms_data', JSON.stringify(cmsData))

      const params = {
        cms_user_id: user?.user_id + '_' + contractData?.contract,
        contract_id: contractData?.contract || '',
        company_from: data?.company_from || companyFromId,
        company_to: data?.company_to || companyId
      }
      fd.append('data', JSON.stringify(params))

      const response = await saveCmsData(fd);
      if (response.data?.result === 'success') {
        alert(response.data?.msg)
        setAgreeFile(undefined)
      }

      setIsLoading(false)
      setModalShow2(false)

    } catch (e) {
      console.log(e)
      setIsLoading(false)
    }
  }

  const requestPay = () => {
    IMP.init("imp41866208")
    IMP.request_pay({
      pg: 'nice',
      pay_method: payMethod || 'card',
      currency: undefined,
      notice_url: undefined,
      display: undefined,
      merchant_uid: `mid_${new Date().getTime()}`,
      name: company.name + ' ' + prevDate,
      //amount : data.price || 0,
      amount: 1000,
      app_scheme: 'wasteverse',
      tax_free: undefined,
      buyer_name: company.name || '회사명',
      buyer_tel: company.mobile_phone || '회사모바일번호',
      buyer_email: company.email || '회사이메일',
      buyer_addr: undefined,
      buyer_postcode: undefined,
      custom_data: undefined,
      vbank_due: undefined,
      digital: false,
      language: undefined,
      biz_num: undefined,
      customer_uid: undefined,
      naverPopupMode: undefined,
      naverUseCfm: undefined,
      naverProducts: undefined,
      m_redirect_url: undefined,
      niceMobileV2: true,
      escrow: false,
    }, function (response) { // callback
      setRsp(response)
      if (response.success) {
        savePaymentLog('Y', response)
        savePayment(response)
        setModalSuccess(true)
      } else {
        savePaymentLog('N', response)
        alert("결제에 실패하였습니다. \n에러내용: " + response.error_msg)
      }
    });
  }

  const savePaymentLog = async (state, response) => {
    const params = {
      company_from: order?.companyFrom,
      company_to: order?.companyTo,
      payment_report: order?.paymentReportId,
      payment_type: 'card',
      imp_uid: response?.imp_uid,
      merchant_uid: response.merchant_uid,
      price: order?.totalPrice,
      status: state
    }
    const rs = await postPaymentLog(params);
  }

  const savePayment = async (response) => {
    setIsLoading(true)
    const params = {
      company_from: order?.companyFrom,
      company_to: order?.companyTo,
      payment_report: order?.paymentReportId,
      payment_type: 'card',
      imp_uid: response?.imp_uid,
      merchant_uid: response.merchant_uid,
      price: order?.totalPrice,
      status: 'Y'
    }
    const rs = await postPaymentReport(params);
    if(rs.data?.result === 'success'){
      saveTaxBill()
      getDataList()
    }
    setIsLoading(false)
  }

  const saveTaxBill = async () => {

    const toDate = moment(new Date()).format('YYYYMMDD');
    const mgtKey = toDate + '-' + order?.paymentReportId;

    const fromRs = await getCompanyOrder(order?.companyFrom);
    const fromData = fromRs.data || {}

    const toRs = await getCompanyOrder(order?.companyTo);
    const toData = toRs.data || {}

    const params = {
      payment_report_id: order?.paymentReportId,
      company_from_number: fromData.company_number,
      company_from_name: fromData.name,
      company_from_user_name: fromData.username,
      company_from_address: fromData.address1 + fromData.address2,
      company_from_email: fromData.email,
      company_from_phone: fromData.phone,
      company_from_mobile: fromData.mobile_phone,
      company_from_type: fromData.type,
      company_from_sector: fromData.type,
      company_to_number: toData.company_number,
      company_to_name: toData.name,
      company_to_user_name: toData.username,
      company_to_address: toData.address1 + toData.address2,
      company_to_email: toData.email,
      company_to_phone: toData.phone,
      company_to_mobile: toData.mobile_phone,
      company_to_fax: toData.fax,
      company_to_type: toData.type,
      company_to_sector: toData.type,
      price: parseInt(order?.totalPrice * (10 / 11)),
      vat: order?.totalPrice - parseInt(order?.totalPrice * (10 / 11)),
      total_price: order?.totalPrice,
      mgt_key: mgtKey,
      mgt_date: toDate,
    }
    const response = await postTax(params)
    alert(response.data?.msg || '')
  }

  const modalClose = () => {
    setModalShow(false)
  }

  const modalClose2 = () => {
    setModalShow2(false)
  }

  const modalClose3 = () => {
    setModalShow3(false)
  }

  useEffect(() => {
    getDataList()
    getMyContractList()
  }, [])

  useEffect(() => {
    payMethod && requestPay()
  }, [payMethod])

  const prevPrice = data?.prev_price || 0;
  const payedPrice = data?.payed_price || 0;
  const priceSum = data?.total_price || 0;
  const totalPrice = data?.total_payment_price || 0;
  const totalQty = data?.total_qty_l || 0;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <MetaTags>
            <title>청구서 | 웨이스트버스</title>
          </MetaTags>
          <Breadcrumbs
            maintitle="Home"
            title="청구서"
            breadcrumbItem="청구서"
          />

          <Row>
            <Col md="12">
              <table
                className="body-wrap"
                style={{
                  fontFamily: "Helvetica Neue,Helvetica,Arial,sans-serif",
                  boxSizing: "border-box",
                  fontSize: "14px",
                  width: "100%",
                  backgroundColor: "transparent",
                  margin: "0",
                }}
                bgcolor="#f6f6f6"
              >
                <tbody>
                  <tr
                    style={{
                      fontFamily: "Helvetica Neue,Helvetica,Arial,sans-serif",
                      boxSizing: "border-box",
                      fontSize: "14px",
                      margin: "0",
                    }}
                  >
                    <td
                      className="container"
                      width="600"
                      style={{
                        fontFamily:
                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                        boxSizing: "border-box",
                        fontSize: "14px",
                        verticalAlign: "top",
                        display: "block",
                        maxWidth: "600px",
                        clear: "both",
                        margin: "0",
                      }}
                      valign="top"
                    >
                      <div
                        className="content"
                        style={{
                          fontFamily:
                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                          boxSizing: "border-box",
                          fontSize: "14px",
                          maxWidth: "600px",
                          display: "block",
                          margin: "0",
                          padding: "26px 0 0 0",
                        }}
                      >
                        <table
                          className="main"
                          width="100%"
                          cellPadding="0"
                          cellSpacing="0"
                          style={{
                            fontFamily:
                              "Helvetica Neue,Helvetica,Arial,sans-serif",
                            boxSizing: "border-box",
                            fontSize: "14px",
                            borderRadius: "7px",
                            margin: "0",
                            border: "none",
                          }}
                        >
                          <tbody>
                            <tr
                              style={{
                                fontFamily:
                                  "Helvetica Neue,Helvetica,Arial,sans-serif",
                                boxSizing: "border-box",
                                fontSize: "14px",
                                margin: "0",
                              }}
                            >
                              <td
                                className="content-wrap aligncenter"
                                style={{
                                  fontFamily:
                                    "Helvetica Neue,Helvetica,Arial,sans-serif",
                                  boxSizing: "border-box",
                                  fontSize: "14px",
                                  verticalAlign: "top",
                                  margin: "0",
                                  padding: "20px",
                                  //border: "3px solid #1d1e3a",
                                  borderRadius: "7px",
                                  backgroundColor: "#fff",
                                  filter: 'drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.03))'
                                }}
                                align="center"
                                valign="top"
                              >
                                <table
                                  width="100%"
                                  cellPadding="0"
                                  cellSpacing="0"
                                  style={{
                                    fontFamily:
                                      "Helvetica Neue,Helvetica,Arial,sans-serif",
                                    boxSizing: "border-box",
                                    fontSize: "14px",
                                    margin: "0",
                                  }}
                                >
                                  <tbody>
                                    <tr
                                      style={{
                                        fontFamily:
                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                        boxSizing: "border-box",
                                        fontSize: "14px",
                                        margin: "0",
                                      }}
                                    >
                                      <td
                                        className="content-block"
                                        style={{
                                          fontFamily:
                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                          boxSizing: "border-box",
                                          fontSize: "14px",
                                          verticalAlign: "top",
                                          margin: "0",
                                          padding: "0 0 20px",
                                        }}
                                        valign="top"
                                      >
                                        <h2
                                          className="aligncenter"
                                          style={{
                                            fontFamily:
                                              "Helvetica Neue,Helvetica,Arial,Lucida Grande,sans-serif",
                                            boxSizing: "border-box",
                                            fontSize: "24px",
                                            color: "#000",
                                            lineHeight: "1.4em",
                                            fontWeight: "400",
                                            textAlign: "center",
                                            margin: "40px 0 0",
                                          }}
                                          align="center"
                                        >
                                          <b style={{ fontWeight: "600" }}>{prevDate}</b> 결제 예정 금액은{" "}
                                          <b style={{ fontWeight: "600", color: '#FF4949' }}>
                                            {" "}
                                            <br />{Util.setCommaPrice(totalPrice)}
                                          </b>
                                          원 입니다.
                                        </h2>
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        fontFamily:
                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                        boxSizing: "border-box",
                                        fontSize: "14px",
                                        margin: "0",
                                      }}
                                    >
                                      <td
                                        className="content-block aligncenter"
                                        style={{
                                          fontFamily:
                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                          boxSizing: "border-box",
                                          fontSize: "14px",
                                          verticalAlign: "top",
                                          textAlign: "center",
                                          margin: "0",
                                          padding: "0 0 20px",
                                        }}
                                        align="center"
                                        valign="top"
                                      >
                                        <table
                                          className="invoice"
                                          style={{
                                            fontFamily:
                                              "Helvetica Neue,Helvetica,Arial,sans-serif",
                                            boxSizing: "border-box",
                                            fontSize: "14px",
                                            textAlign: "left",
                                            width: "80%",
                                            margin: "40px auto",
                                          }}
                                        >
                                          <tbody>
                                            <tr
                                              style={{
                                                fontFamily:
                                                  "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                boxSizing: "border-box",
                                                fontSize: "14px",
                                                margin: "0",
                                              }}
                                            >
                                              <td
                                                style={{
                                                  fontFamily:
                                                    "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                  boxSizing: "border-box",
                                                  fontSize: "14px",
                                                  verticalAlign: "top",
                                                  margin: "0",
                                                  padding: "5px 0",
                                                }}
                                                valign="top"
                                              >
                                                <b className="font-weight-bold">{company?.name}</b>
                                                <br />
                                                <br />
                                                <table className="w-100">
                                                  <tbody>
                                                    <tr>
                                                      <td className="d-flex justify-content-between align-items-center">
                                                        <p className="mb-0">정산요약</p>
                                                        {isCms === 'N' &&
                                                          <button className="btn btn-primary w-md waves-effect waves-light" style={{ float: 'right' }} onClick={()=>{setModalShow2(true)}}>CMS 신청
                                                          </button>
                                                        }
                                                        {isCms === 'I' &&
                                                          <div style={{ cursor: 'auto', fontSize: 14, color: '#C9CACA' }}>CMS 대기중
                                                          </div>
                                                        }
                                                        {isCms === 'Y' &&
                                                          <div style={{ cursor: 'auto', fontSize: 14, color: '#333' }}>CMS 사용중
                                                          </div>
                                                        }
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                            <tr
                                              style={{
                                                fontFamily:
                                                  "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                boxSizing: "border-box",
                                                fontSize: "14px",
                                                margin: "0",
                                              }}
                                            >
                                              <td
                                                style={{
                                                  fontFamily:
                                                    "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                  boxSizing: "border-box",
                                                  fontSize: "14px",
                                                  verticalAlign: "top",
                                                  margin: "0",
                                                  padding: "5px 0",
                                                }}
                                                valign="top"
                                              >
                                                <table
                                                  className="invoice-items"
                                                  cellPadding="0"
                                                  cellSpacing="0"
                                                  style={{
                                                    fontFamily:
                                                      "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                    boxSizing: "border-box",
                                                    fontSize: "14px",
                                                    width: "100%",
                                                    margin: "0",
                                                  }}
                                                >
                                                  <tbody>
                                                    <tr
                                                      style={{
                                                        fontFamily:
                                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                        boxSizing:
                                                          "border-box",
                                                        fontSize: "14px",
                                                        margin: "0",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          borderTopWidth:
                                                            "1px",
                                                          borderTopColor:
                                                            "#eee",
                                                          borderTopStyle:
                                                            "solid",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                        }}
                                                        valign="top"
                                                      >
                                                        당월미정산액
                                                      </td>
                                                      <td
                                                        className="alignright"
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          textAlign: "right",
                                                          borderTopWidth:
                                                            "1px",
                                                          borderTopColor:
                                                            "#eee",
                                                          borderTopStyle:
                                                            "solid",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                          whiteSpace: 'nowrap'
                                                        }}
                                                        align="right"
                                                        valign="top"
                                                      >
                                                        {Util.setCommaPrice(priceSum)}원
                                                      </td>
                                                    </tr>
                                                    <tr
                                                      style={{
                                                        fontFamily:
                                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                        boxSizing:
                                                          "border-box",
                                                        fontSize: "14px",
                                                        margin: "0",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          borderTopWidth:
                                                            "1px",
                                                          borderTopColor:
                                                            "#eee",
                                                          borderTopStyle:
                                                            "solid",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                        }}
                                                        valign="top"
                                                      >
                                                        이전미정산액
                                                      </td>
                                                      <td
                                                        className="alignright"
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          textAlign: "right",
                                                          borderTopWidth:
                                                            "1px",
                                                          borderTopColor:
                                                            "#eee",
                                                          borderTopStyle:
                                                            "solid",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                          whiteSpace: 'nowrap'
                                                        }}
                                                        align="right"
                                                        valign="top"
                                                      >
                                                        {Util.setCommaPrice(prevPrice)}원
                                                      </td>
                                                    </tr>
                                                    <tr
                                                      style={{
                                                        fontFamily:
                                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                        boxSizing:
                                                          "border-box",
                                                        fontSize: "14px",
                                                        margin: "0",
                                                      }}
                                                    >
                                                    </tr>
                                                    <tr
                                                      className="total"
                                                      style={{
                                                        fontFamily:
                                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                        boxSizing:
                                                          "border-box",
                                                        fontSize: "14px",
                                                        margin: "0",
                                                      }}
                                                    >
                                                      <td
                                                        className="alignright"
                                                        width="80%"
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          textAlign: "right",
                                                          borderTopWidth:
                                                            "2px",
                                                          borderTopColor:
                                                            "#333",
                                                          borderTopStyle:
                                                            "solid",
                                                          borderBottomColor:
                                                            "#333",
                                                          borderBottomWidth:
                                                            "2px",
                                                          borderBottomStyle:
                                                            "solid",
                                                          fontWeight: "700",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                        }}
                                                        align="right"
                                                        valign="top"
                                                      >
                                                        합계
                                                      </td>
                                                      <td
                                                        className="alignright"
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          textAlign: "right",
                                                          borderTopWidth:
                                                            "2px",
                                                          borderTopColor:
                                                            "#333",
                                                          borderTopStyle:
                                                            "solid",
                                                          borderBottomColor:
                                                            "#333",
                                                          borderBottomWidth:
                                                            "2px",
                                                          borderBottomStyle:
                                                            "solid",
                                                          fontWeight: "700",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                          whiteSpace: 'nowrap'
                                                        }}
                                                        align="right"
                                                        valign="top"
                                                      >
                                                        {Util.setCommaPrice(totalPrice)}원
                                                      </td>
                                                    </tr>
                                                    <tr
                                                      className="total"
                                                      style={{
                                                        fontFamily:
                                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                        boxSizing:
                                                          "border-box",
                                                        fontSize: "14px",
                                                        margin: "0",
                                                      }}
                                                    >
                                                      <td
                                                        className="alignright"
                                                        width="80%"
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          textAlign: "right",
                                                          borderTopWidth:
                                                            "2px",
                                                          borderTopColor:
                                                            "#333",
                                                          borderTopStyle:
                                                            "solid",
                                                          borderBottomColor:
                                                            "#333",
                                                          borderBottomWidth:
                                                            "2px",
                                                          borderBottomStyle:
                                                            "solid",
                                                          fontWeight: "700",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                        }}
                                                        align="right"
                                                        valign="top"
                                                      >
                                                        결제한 금액
                                                      </td>
                                                      <td
                                                        className="alignright"
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          textAlign: "right",
                                                          borderTopWidth:
                                                            "2px",
                                                          borderTopColor:
                                                            "#333",
                                                          borderTopStyle:
                                                            "solid",
                                                          borderBottomColor:
                                                            "#333",
                                                          borderBottomWidth:
                                                            "2px",
                                                          borderBottomStyle:
                                                            "solid",
                                                          fontWeight: "700",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                          color: 'blue',
                                                          whiteSpace: 'nowrap'
                                                        }}
                                                        align="right"
                                                        valign="top"
                                                      >
                                                        {Util.setCommaPrice(payedPrice)}원
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        {!isPayment ?
                                          <div style={{ cursor: 'auto', fontSize: 16, fontWeight: "bold", color: '#C9CACA' }}>본점에서 통합결제 합니다
                                          </div>
                                          : data?.state !== 'Y' && totalPrice > 0 ?
                                            isCms === 'Y' ?
                                              <div style={{ cursor: 'auto', fontSize: 16, fontWeight: "bold", color: '#C9CACA' }}>
                                                {totalPrice > 0 ? '결제 대기중' : '결제하실 금액이 없습니다'}
                                              </div>
                                              :
                                              <button className="btn btn-primary w-md waves-effect waves-light" type="submit" onClick={() => {
                                                setModalShow(true)
                                              }}>정산하기(즉시결제)
                                              </button>
                                            :
                                            <div style={{ cursor: 'auto', fontSize: 16, fontWeight: "bold", color: '#C9CACA' }}>
                                              {totalPrice > 0 ? '결제가 완료되었습니다' : '결제하실 금액이 없습니다'}
                                            </div>
                                        }
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{ textAlign: "center", fontSize: 16, fontWeight: "bold", color: 'black' }}>
                                        <p style={{ cursor: "pointer" }} onClick={() => {
                                          history.push('settlement-details')
                                        }}>정산 내역{isPayment && ' / 고지 내역'}</p>
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        fontFamily:
                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                        boxSizing: "border-box",
                                        fontSize: "14px",
                                        margin: "0",
                                      }}
                                    >
                                      <td
                                        className="content-block aligncenter"
                                        style={{
                                          fontFamily:
                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                          boxSizing: "border-box",
                                          fontSize: "14px",
                                          verticalAlign: "top",
                                          textAlign: "center",
                                          margin: " 0",
                                          padding: " 0 0 20px",
                                        }}
                                        align="center"
                                        valign="top"
                                      >
                                      </td>
                                    </tr>

                                    <tr
                                      style={{
                                        fontFamily:
                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                        boxSizing: "border-box",
                                        fontSize: "14px",
                                        margin: "0",
                                      }}
                                    >
                                      <td
                                        className="content-block"
                                        style={{
                                          textAlign: "center",
                                          fontFamily:
                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                          boxSizing: "border-box",
                                          fontSize: "14px",
                                          verticalAlign: "top",
                                          margin: "0",
                                          padding: "0",
                                        }}
                                        valign="top"
                                      >
                                        © {new Date().getFullYear()} Wasteverse
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
        </Container>
      </div>
      {modalSuccess &&
        <div style={{
          position: "fixed",
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          background: 'rgba(0, 0, 0, 0.4)',
          zIndex: 999,
          display: "flex",
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <div style={{ width: 480, height: 300, backgroundColor: "#fff", zIndex: 1000, padding: 36 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ fontSize: 20, color: 'black', fontWeight: 'bold' }}>결제완료</p>
              <p style={{ cursor: "pointer", fontSize: 20 }} onClick={() => {
                setModalSuccess(false)
              }}>X</p>
            </div>
            <div style={{ padding: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p style={{ fontSize: 16 }}>주문번호</p>
                <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold' }}>{rsp.merchant_uid?.split('_')?.[1]}</p>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: 24 }}>
                <p style={{ fontSize: 16, color: 'black', fontWeight: 'bold' }}>{order.prevMonth + '월분 ' + Util.setCommaPrice(order.totalPrice) + '원 결제가 완료되었습니다.'}</p>
              </div>
            </div>
          </div>
        </div>
      }
      <Modal title={'결제수단 선택'} show={modalShow} onHide={modalClose} size="sm">
        <div style={{ zIndex: 1, minHeight: '160px' }}>
          <div className="position-relative app-search d-none d-lg-block" style={{ padding: 0, marginBottom: "1rem" }}>
          </div>
          <div style={{ position: "relative", minHeight: '160px', overflowY: "auto" }}>
            <div style={{ position: "absolute", minHeight: '160px', right: 0, left: 0, overflowX: "hidden" }}>
              {payMethodArr && payMethodArr.map((item) => {
                return (
                  <div style={isHover == item.key ? { ...style, ...hoverStyle } : { ...style }} key={item.key}
                    onMouseOver={() => {
                      setIsHover(item.key)
                    }}
                    onMouseLeave={() => {
                      setIsHover(false)
                    }}
                    onClick={() => {
                      setPayMethod(item.key)
                      modalClose()
                      setOrder({
                        price: data?.price,
                        vat: data?.vat,
                        totalSum: totalQty,
                        totalPrice: totalPrice,
                        prevMonth: prevMonth,
                        companyFrom: data?.company_from,
                        companyTo: data?.company_to,
                        paymentReportId: data?.id
                      })
                    }}>{item.text}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </Modal>
      <Modal title={'CMS 신청'} show={modalShow2} onHide={modalClose2} size="md">
        <div style={{ zIndex: 1, minHeight: '440px' }}>
          <div className="position-relative app-search d-none d-lg-block" style={{ padding: 0, marginBottom: "1rem" }}>
          </div>
          <div style={{ position: "relative", minHeight: '440px', overflowY: "auto" }}>
            <div style={{ position: "absolute", minHeight: '440px', right: 0, left: 0, overflowX: "hidden" }}>
              <div className="d-flex justify-content-between padding-right-16 padding-left-16 align-items-center">
                <p className="font-size-16 text-black">업체명</p>
                <p className="font-size-18 text-black font-weight-bold">{company?.name}</p>
              </div>
              <div className="d-flex justify-content-between padding-right-16 padding-left-16 align-items-center">
                <p className="font-size-16 text-black">이름</p>
                <p className="font-size-18 text-black font-weight-bold">{user?.username}</p>
              </div>
              <div className="d-flex justify-content-between padding-right-16 padding-left-16 align-items-center">
                <p className="font-size-16 text-black">사업자번호</p>
                <p className="font-size-18 text-black font-weight-bold">{Util.checkBusinessNumber(company?.company_number)}</p>
              </div>
              <div className="d-flex justify-content-between padding-right-16 padding-left-16 align-items-center mb-3">
                <p className="font-size-16 text-black mb-0">은행</p>
                <div className="waver-pagination-btn-group d-flex align-items-center" >
                  <p className="mb-0 font-size-18 font-weight-bold text-black padding-right-8">{cmsBank?.text}</p>
                  <button className="waves-effect submit-btn btn btn-secondary font-size-16"
                    onClick={() => {
                    openBankModal()
                    }}
                  >은행선택</button>
                </div>
              </div>
              <div className="d-flex justify-content-between padding-right-16 padding-left-16 mb-4 align-items-center">
                <p className="font-size-16 text-black noMargin">계좌번호</p>
                <input className="is-touched is-dirty av-valid form-control font-size-16" style={{width: 240}} placeholder="'-' 없이 입력해주세요." 
                onChange={(e)=>{
                  setBankAccount(e.target.value)
                }} />
              </div>
              <div className="d-flex justify-content-between padding-right-16 padding-left-16 mb-4 align-items-center">
                <p className="font-size-16 text-black mb-0">동의서 파일 첨부</p>
                <label className="btn btn-primary waves-effect waves-light" htmlFor={'acceptFile'} style={{height: 36, marginRight: 0}}>파일 선택</label>
                <input style={{display: "none"}} accept=".pdf" type="file" id={'acceptFile'} onChange={(e)=>{
                    setAgreeFile(e.target.files[0])
                }}/>
              </div>
              {agreeFile && 
                <div className="file-confirm margin-left-16">
                  <p className="noMargin">{agreeFile.name}</p>
                  <Delete className="margin-left-8 pointer" onClick={()=>{setAgreeFile(undefined)}} />
                </div>
              }
              <div className="row">
                <div className="col-12 text-center">
                  <button
                    className="btn btn-primary w-md waves-effect waves-light mt-5"
                    onClick={() => {
                      saveCmsMember()
                    }}
                  >
                    CMS 신청하기
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal title={'은행 선택'} show={modalShow3} onHide={modalClose3} size="sm">
        <div style={{ zIndex: 1, minHeight: '400px' }}>
          <div className="position-relative app-search d-none d-lg-block" style={{ padding: 0, marginBottom: "1rem" }}>
          </div>
          <div style={{ position: "relative", minHeight: '400px', overflowY: "auto" }}>
            <div style={{ position: "absolute", minHeight: '400px', right: 0, left: 0, overflowX: "hidden" }}>
              {bankList && bankList.map((item) => {
                return (
                  <div style={isHover == item.code ? { ...style, ...hoverStyle } : { ...style }} key={item.code}
                    onMouseOver={() => {
                      setIsHover(item.code)
                    }}
                    onMouseLeave={() => {
                      setIsHover(false)
                    }}
                    onClick={() => {
                      selectBank(item)
                    }}>{item.text}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </Modal>
      {isLoading && <div style={{
        position: "absolute",
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: 'rgba(255, 255, 255, 0.6)',
        zIndex: 999,
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img src={loading} alt="로딩중입니다." width={'5%'}></img>
      </div>}
    </React.Fragment>
  )
}

export default EmitterBill;
